import BotProfileDialog from "../playerlist/botprofiledialog";
import UserProfileDialog from "../../../user/userprofiledialog";
import { ApiSeat } from "../../../../src/types/apigame"

type Props = {
    isOpen: boolean;
    seatObject: ApiSeat;
    onClose: () => void;
}

export default function PlayerProfileDialog(
    {
        isOpen,
        seatObject,
        onClose,
    }: Props,
): JSX.Element {
    if (seatObject.userId) {
        return <UserProfileDialog
            isOpen={isOpen}
            userId={seatObject.userId}
            onClose={onClose}
        />;
    } else {
        return <BotProfileDialog
            isOpen={isOpen}
            seatObject={seatObject}
            onClose={onClose}
        />;
    }
}
